import React, { useState } from 'react';
import { useTranslation } from "react-i18next";

import { removeFromTeam, removeFromClub } from "../services/users";

export const RemoveUserDialog = ({ children, user, teamId, onClose }) => {
  const [errors, setErrors] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();

  const open = () => {
    setShow(true)
  }

  const removeCoach = async (fromTeam) => {
    setLoading(true)
    const request = fromTeam ? () => removeFromTeam(teamId, user.id) : () => removeFromClub(user.id)
    try {
      await request();
      close(true)
    } catch (e) {
      if (e?.response?.data?.errors) setErrors(e?.response?.data?.errors)
    }
    setLoading(false)
  }

  const close = (reload) => {
    setShow(false);
    reload && onClose && onClose(reload);
  }

  return (
    <>
      <span onClick={open}>{children || <button className="button button-delete"><span className="icon icon-user-unfollow"></span> {t('coaches.remove_coach')}</button>}</span>
      { show && 
        <div className="dialog">
          <div className="dialog-content">
            <div className="form-group">
              <label htmlFor="groupName">{t('coaches.remove.confirmation', {name: user?.name})}</label>
            </div>
            <div className="form-container-actions">
              <div className="flex-end form-actions">
                <button className="button" onClick={() => close()} disabled={loading}>
                  {t('buttons.common.cancel')}
                </button>
                <button className="button button-delete" onClick={() => {removeCoach(false)}} disabled={loading}>
                  {t('coaches.remove.from_club_button')}
                </button>
                { teamId && <button className="button button-delete" onClick={() => {removeCoach(true)}} disabled={loading}>
                  {t('coaches.remove.from_team_button')}
                </button> }
              </div>
            </div>
          </div>
        </div>
      }
    </>
  )
}
